import styled from 'styled-components';

const IntroBlockStyle = styled.div`
  p {
    font-size: 20px;
  }
`;

export default IntroBlockStyle;
